import React from 'react';
import { Phone, MapPin, Facebook, Instagram, ArrowUp } from 'lucide-react';
import { useSettings } from '../hooks/useSettings';

const Footer = () => {
  const settings = useSettings();
  const whatsappNumber = settings.whatsappNumber;
  const whatsappLink = `https://wa.me/6${whatsappNumber}`;
  const facebookLink = 'https://www.facebook.com/share/19gbRX5nP6/?mibextid=wwXIfr';

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/dtvdudhd_IMG_1203.png" 
                alt="Gudang Boss Ijan"
                className="h-12 w-auto brightness-0 invert"
              />
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-4 max-w-md">
              Gudang perabot jati terbesar di Malaysia. Terus dari Jepara dengan kualiti premium dan harga mampu milik.
            </p>
            <div className="flex gap-3">
              <a 
                href={facebookLink}
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 bg-gray-800 hover:bg-blue-600 rounded-lg flex items-center justify-center transition-colors"
                aria-label="Facebook"
              >
                <Facebook size={18} />
              </a>
              <a 
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 bg-gray-800 hover:bg-green-600 rounded-lg flex items-center justify-center transition-colors"
                aria-label="WhatsApp"
              >
                <Phone size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider text-gray-400 mb-4">Pautan</h3>
            <ul className="space-y-2">
              {[
                { href: '#perabot', label: 'Produk' },
                { href: '#category', label: 'Kategori' },
                { href: '#tentang', label: 'Tentang Kami' },
                { href: '#testimoni', label: 'Testimoni' },
                { href: '#lokasi', label: 'Lokasi' },
              ].map((link) => (
                <li key={link.href}>
                  <a href={link.href} className="text-gray-400 hover:text-white text-sm transition-colors">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider text-gray-400 mb-4">Hubungi Kami</h3>
            <div className="space-y-3">
              <a href={whatsappLink} className="flex items-center gap-2 text-gray-400 hover:text-white text-sm transition-colors">
                <Phone size={16} className="text-green-500" />
                <span>{whatsappNumber}</span>
              </a>
              <div className="flex items-center gap-2 text-gray-400 text-sm">
                <MapPin size={16} className="text-amber-500" />
                <span>Johor, Malaysia</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 py-4 flex flex-col sm:flex-row justify-between items-center gap-2">
          <p className="text-gray-500 text-xs">
            &copy; {new Date().getFullYear()} Gudang Boss Ijan. Semua Hak Terpelihara.
          </p>
          <button 
            onClick={scrollToTop}
            className="text-gray-500 hover:text-white text-xs flex items-center gap-1 transition-colors"
          >
            Kembali ke atas
            <ArrowUp size={14} />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
